// GENERATED USING CHATGPT
import { MondayItemType } from "../../monday-import-items.types";

export function generateDragPreview(
  items: MondayItemType[],
  colors: Record<string, string>
): Promise<HTMLImageElement> {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      resolve(new Image());
      return;
    }

    // Set canvas dimensions
    const cardWidth = 280;
    const cardHeight = 40;
    const offset = 4;
    const numCards = Math.min(items.length, 3);
    const totalHeight = cardHeight + (numCards - 1) * offset + 30; // Extra space for badge
    const totalWidth = cardWidth + (numCards - 1) * offset + 10;

    canvas.width = totalWidth;
    canvas.height = totalHeight;

    // Clear background
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw stacked cards effect
    items.slice(0, 3).forEach((item, index) => {
      const x = index * offset;
      const y = index * offset;

      // Card shadow
      ctx.save();
      ctx.shadowColor = "rgba(0, 0, 0, 0.1)";
      ctx.shadowBlur = 8;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 2;

      // Card background
      ctx.fillStyle = "white";
      ctx.fillRect(x, y, cardWidth, cardHeight);
      ctx.restore();

      // Border
      ctx.strokeStyle = "rgba(0, 0, 0, 0.1)";
      ctx.lineWidth = 1;
      ctx.strokeRect(x, y, cardWidth, cardHeight);

      // Indicator
      ctx.fillStyle = colors[item.id] || "#5C6C7C";
      ctx.fillRect(x + 12, y + 8, 3, cardHeight - 16);

      // Text
      ctx.fillStyle = "#323338";
      ctx.font = "14px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

      // Truncate text if too long
      const maxWidth = cardWidth - 40;
      let text = item.name;
      const textWidth = ctx.measureText(text).width;
      if (textWidth > maxWidth) {
        while (ctx.measureText(text + "...").width > maxWidth && text.length > 0) {
          text = text.slice(0, -1);
        }
        text += "...";
      }

      ctx.fillText(text, x + 24, y + cardHeight / 2 + 5);
    });

    // Draw badge
    const badgeText = `${items.length} ${items.length === 1 ? "item" : "items"}`;
    ctx.font = "11px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
    const badgeWidth = ctx.measureText(badgeText).width + 16;
    const badgeX = (cardWidth + (numCards - 1) * offset) / 2 - badgeWidth / 2;
    const badgeY = (numCards - 1) * offset + cardHeight + 8;

    // Badge shadow
    ctx.save();
    ctx.shadowColor = "rgba(0, 0, 0, 0.2)";
    ctx.shadowBlur = 4;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 2;

    // Draw rounded rectangle for badge
    const radius = 10;
    ctx.fillStyle = "#0073ea";
    ctx.beginPath();
    ctx.moveTo(badgeX + radius, badgeY);
    ctx.lineTo(badgeX + badgeWidth - radius, badgeY);
    ctx.quadraticCurveTo(badgeX + badgeWidth, badgeY, badgeX + badgeWidth, badgeY + radius);
    ctx.lineTo(badgeX + badgeWidth, badgeY + 20 - radius);
    ctx.quadraticCurveTo(badgeX + badgeWidth, badgeY + 20, badgeX + badgeWidth - radius, badgeY + 20);
    ctx.lineTo(badgeX + radius, badgeY + 20);
    ctx.quadraticCurveTo(badgeX, badgeY + 20, badgeX, badgeY + 20 - radius);
    ctx.lineTo(badgeX, badgeY + radius);
    ctx.quadraticCurveTo(badgeX, badgeY, badgeX + radius, badgeY);
    ctx.closePath();
    ctx.fill();
    ctx.restore();

    // Badge text
    ctx.fillStyle = "white";
    ctx.font = "11px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText(badgeText, badgeX + badgeWidth / 2, badgeY + 14);

    // Create image from canvas
    const img = new Image();
    img.src = canvas.toDataURL();
    img.onload = () => {
      resolve(img);
    };
    img.onerror = () => {
      resolve(new Image());
    };
  });
}
